import React from 'react';

interface IniciativaDirecionadorProps {
  direcionadorEstrategico?: string;
  texto: string;
}

export const IniciativaDirecionador: React.FC<IniciativaDirecionadorProps> = ({
  direcionadorEstrategico,
  texto,
}) => {
  const pergunta = direcionadorEstrategico
    ? `Por que essa iniciativa foi fundamental para o atingimento da
                Perspectiva ECBB: "${direcionadorEstrategico}"?`
    : 'Por que essa iniciativa foi fundamental para o atingimento do direcionador estratégico a ela vinculado e que resultado ela gerou?';

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <h3 className="text-sm font-bold text-[#1e3a5f] mt-0 mb-3 leading-snug">{pergunta}</h3>
      <p className="text-sm text-gray-500 leading-7 m-0">{texto}</p>
    </div>
  );
};
